import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation('common');
  return (
    <Center mih="60vh">
      <Stack align="center">
        <Title order={1}>404</Title>
        <Text c="dimmed">{t('state.notFound')}</Text>
        <Button component={Link} to="/">
          {t('nav.cockpit')}
        </Button>
      </Stack>
    </Center>
  );
}
